import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import actions from 'actions/filterTemplates'
import Component from 'components/Reports/Schedule/Filter'

const mapStateToProps = (state, props) => ({ ...createAuthStateToProps(state, props) })

export default connect(mapStateToProps, { getFilterTemplateTypes: actions.getFilterTypes })(Component)
